module.exports = __webpack_public_path__ + "static/img/1.MRT-SATA-Card.4bf22e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/1.MRT-SATA-Card.jpg
// module id = i+Lh
// module chunks = 1